import { Button, IconModal, Input, InputOTP, Lock } from '@airtm/airtm-ui';
import React, { useEffect } from 'react';

type Props = {
  invalidCode: boolean;
  isOpen: boolean;
  submitting: boolean;
  textCancelButton: string;
  textInvalidCode: string;
  textLabelCode: string;
  title: string;
  onCancel: () => void;
  onSubmit: ({ mfaCode }: { mfaCode: string }) => void;
};

type TFAInputProps = {
  label: string;
  value: string;
  onChange: (value: string) => void;
  onBlur?: (e: any) => void;
  errors?: Array<string>;
  helpText?: string;
  disabled?: boolean;
  autoFocus?: boolean;
};

export const TFAInput = function ({
  label,
  value,
  onChange,
  onBlur,
  errors,
  helpText,
  ...inputProps
}: TFAInputProps) {
  const handleOnChange = (newValue: string) => {
    onChange(newValue);
  };

  return (
    <div className="d-flex flex-column align-items-start justify-content-start">
      <InputOTP
        autoFocus
        id="pass2fa"
        name="code"
        value={value}
        onChange={handleOnChange}
        onBlur={onBlur}
        label={label}
        invalid={!!errors?.length}
        {...inputProps}
      />
      {helpText && <Input.HelperText key={helpText}>{helpText}</Input.HelperText>}
      {errors?.map((error) => (
        <Input.HelperText invalid key={error}>
          {error}
        </Input.HelperText>
      ))}
    </div>
  );
};

const MfaForm = function ({
  invalidCode,
  isOpen,
  onCancel,
  onSubmit,
  submitting,
  textCancelButton,
  textInvalidCode,
  textLabelCode,
  title,
}: Props) {
  const [code, setCode] = React.useState('');

  const onCodeChange = (value: string) => {
    setCode(value);
    if (value.length === 6) {
      onSubmit({ mfaCode: value });
    }
  };

  // clean the input on close
  useEffect(() => {
    if (!isOpen) setCode('');
  }, [isOpen]);

  useEffect(() => {
    if (invalidCode && code.length === 6) {
      setCode('');
    }
  }, [invalidCode]);

  return (
    <IconModal modalClose={onCancel} show={isOpen}>
      <IconModal.Body icon={<Lock />} title={title}>
        <div>
          <TFAInput
            label={textLabelCode}
            value={code}
            onChange={onCodeChange}
            errors={invalidCode ? [textInvalidCode] : undefined}
          />
        </div>
      </IconModal.Body>
      <IconModal.Actions>
        <Button variant="destructive" disabled={submitting} onClick={onCancel}>
          {textCancelButton}
        </Button>
      </IconModal.Actions>
    </IconModal>
  );
};

export default MfaForm;
